import { render, staticRenderFns } from "./Special2.vue?vue&type=template&id=50b07bf4&scoped=true"
import script from "./Special2.vue?vue&type=script&lang=js"
export * from "./Special2.vue?vue&type=script&lang=js"
import style0 from "./Special2.vue?vue&type=style&index=0&id=50b07bf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b07bf4",
  null
  
)

export default component.exports